'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRootSearchPath = exports.mapVenue = exports.makeUrlFromLayout = exports.selectFiltersFromHash = exports.selectLocationAutoCompleteFromHash = exports.selectResultsFromLayout = exports.selectLocationAutocompleteValueInLayout = exports.selectKeywordAutocompleteValueInLayout = exports.selectResolvedFilterDataInLayout = exports.selectFiltersForHashInLayout = exports.selectMetadataInLayout = exports.selectSearchIdInLayout = exports.selectCursorInLayout = exports.selectMapItemsInLayout = exports.selectVenuesInLayout = exports.selectSchedulesInLayout = exports.selectTotalHitsInLayout = exports.selectHasAccessToSearch = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _bound = require('redux/saga/entities/bound');

var _deep = require('helpers/deep');

var _Search = require('./Search.constants');

var _Search2 = require('./Search.route');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectHasAccessToSearch = exports.selectHasAccessToSearch = function selectHasAccessToSearch(state) {
  return !!(_bound.userPermissions.data(state) || {})[_Search.SEARCH_ACCESS_PERMISSION];
};

var selectFieldInDataOfLayout = function selectFieldInDataOfLayout(field, defaultValue, layout) {
  return (0, _deep.deepExtract)('data.' + field, layout && layout[(0, _keys2.default)(layout)[0]], defaultValue);
};

var selectTotalHitsInLayout = exports.selectTotalHitsInLayout = selectFieldInDataOfLayout.bind(null, 'total_hits', '');
var selectSchedulesInLayout = exports.selectSchedulesInLayout = selectFieldInDataOfLayout.bind(null, 'schedules', []);
var selectVenuesInLayout = exports.selectVenuesInLayout = selectFieldInDataOfLayout.bind(null, 'venue_tab_items', []);
var selectMapItemsInLayout = exports.selectMapItemsInLayout = selectFieldInDataOfLayout.bind(null, 'map_items', []);
var selectCursorInLayout = exports.selectCursorInLayout = selectFieldInDataOfLayout.bind(null, 'cursor', '');
var selectSearchIdInLayout = exports.selectSearchIdInLayout = selectFieldInDataOfLayout.bind(null, 'search_id', null);
var selectMetadataInLayout = exports.selectMetadataInLayout = selectFieldInDataOfLayout.bind(null, 'filter_metadata', {});
var selectFiltersForHashInLayout = exports.selectFiltersForHashInLayout = selectFieldInDataOfLayout.bind(null, 'filters_for_hash', {});
var selectResolvedFilterDataInLayout = exports.selectResolvedFilterDataInLayout = selectFieldInDataOfLayout.bind(null, 'resolved_filter_data', {});
var selectKeywordAutocompleteValueInLayout = exports.selectKeywordAutocompleteValueInLayout = function selectKeywordAutocompleteValueInLayout(layout) {
  return (0, _deep.deepExtract)('keyword_autocomplete_entry.name', selectResolvedFilterDataInLayout(layout), '');
};
var selectLocationAutocompleteValueInLayout = exports.selectLocationAutocompleteValueInLayout = function selectLocationAutocompleteValueInLayout(layout) {
  return (0, _deep.deepExtract)('location_autocomplete_entry.name', selectResolvedFilterDataInLayout(layout), '');
};

var selectResultsFromLayout = exports.selectResultsFromLayout = function selectResultsFromLayout(state) {
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return _bound.searchLayoutByName.data(state, _Search.RESULTS_LAYOUT + '_page_' + pageNumber);
};

var selectLocationAutoCompleteFromHash = exports.selectLocationAutoCompleteFromHash = function selectLocationAutoCompleteFromHash(state) {
  return (0, _deep.deepExtract)('location_autocomplete_entry', selectResolvedFilterDataInLayout(selectResultsFromLayout(state)), {});
};
var selectFiltersFromHash = exports.selectFiltersFromHash = function selectFiltersFromHash(state) {
  return selectFiltersForHashInLayout(selectResultsFromLayout(state));
};

var makeUrlFromLayout = exports.makeUrlFromLayout = function makeUrlFromLayout(layout) {
  var metadata = selectMetadataInLayout(layout);
  if (metadata.descriptor && metadata.hash) {
    return _Search2.PATH + '/' + metadata.location_descriptor + '/' + metadata.descriptor + '/' + metadata.hash;
  }
};

var mapVenue = exports.mapVenue = function mapVenue(venue) {
  return {
    name: venue.venue_name,
    alias: venue.alias,
    activities: venue.activities,
    location: venue.location_name,
    rating: venue.display_rating_average,
    ratingCount: venue.display_rating_total,
    imageUrl: venue.images && venue.images.default
  };
};

var isRootSearchPath = exports.isRootSearchPath = function isRootSearchPath(pathname) {
  return pathname === _Search2.PATH;
};